/**
 * Same-window events when printer role assignments change (badge / panels refresh).
 */

export const PRINTER_ROLES_CHANGED_EVENT = 'aman:printer-roles-changed';

/**
 * @param {{
 *   role?: string|null,
 *   action?: 'set'|'clear'|'invalidate',
 *   assignment?: { deviceName?: string, displayName?: string }|null
 * }} [detail]
 */
export function notifyPrinterRolesChanged(detail = {}) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return;
  }
  try {
    window.dispatchEvent(
      new CustomEvent(PRINTER_ROLES_CHANGED_EVENT, {
        detail: {
          at: Date.now(),
          ...detail
        }
      })
    );
  } catch {
    /* ignore */
  }
}

/**
 * @param {(ev: CustomEvent) => void} handler
 * @returns {() => void} unsubscribe
 */
export function subscribePrinterRolesChanged(handler) {
  if (typeof window === 'undefined') return () => {};
  const wrapped = (ev) => {
    try {
      handler(ev);
    } catch {
      /* ignore */
    }
  };
  window.addEventListener(PRINTER_ROLES_CHANGED_EVENT, wrapped);
  return () => window.removeEventListener(PRINTER_ROLES_CHANGED_EVENT, wrapped);
}
